/**
 * Redirección post-login para apps de la plataforma.
 * Contrato: /login?redirect=<URL-encoded> donde la URL debe pertenecer a un
 * dominio de la plataforma. URLs externas o inválidas se ignoran (previene open redirect).
 */
const ALLOWED_DOMAINS = ['neokodelabs.com', 'neokode.cl'];

/**
 * Valida una URL de redirección. Retorna la URL absoluta si es válida, o null.
 */
export function validateRedirect(value) {
  if (!value) {
    return null;
  }
  try {
    const url = new URL(value, window.location.origin);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
      return null;
    }
    // Evita loop: redirect apuntando al propio login de esta app
    if (url.origin === window.location.origin && url.pathname.startsWith('/login')) {
      return null;
    }
    const host = url.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return url.href;
    }
    if (ALLOWED_DOMAINS.some((domain) => host === domain || host.endsWith('.' + domain))) {
      return url.href;
    }
    return null;
  } catch (error) {
    return null;
  }
}

/**
 * Lee y valida el parámetro redirect de la URL actual.
 */
export function getRedirectTarget() {
  const params = new URLSearchParams(window.location.search);
  return validateRedirect(params.get('redirect'));
}

/**
 * Ruta al login preservando el redirect vigente (para flujos que vuelven al
 * login sin sesión, como recuperación de contraseña).
 */
export function getLoginPathWithRedirect() {
  const target = getRedirectTarget();
  return target ? '/login?redirect=' + encodeURIComponent(target) : '/';
}
